export const INCIDENT_REPORTING_POLICY = {
  id: 'incident-reporting-policy',
  title: 'Incident Reporting Policy',
  version: 'v1.0-2026-05-17',
  effectiveDate: '17/05/2026',
  audience: 'all',
  content: `INCIDENT REPORTING POLICY — RESERVO

Status: DRAFT — pending solicitor review

1. PURPOSE

This policy describes how incidents are reported, classified, escalated, and recorded on the Reservo platform, including reporting to the NSW Point to Point Transport Commissioner where required.

2. SCOPE

2.1 This policy applies to all incidents arising in connection with a Reservo booking, including:
  (a) collisions or near-miss collisions;
  (b) personal injury (Driver, Rider, third party);
  (c) physical or sexual assault;
  (d) threats or harassment;
  (e) dangerous driving;
  (f) safety concerns (intoxicated driver, unsafe vehicle, fatigue event);
  (g) lost-property reports;
  (h) damage to vehicle or third-party property;
  (i) child-safety concerns (separately covered by Child Safety Policy);
  (j) any other event the reporter considers a safety incident.

2.2 This policy is supplemented by:
  (a) Emergency Response Procedure (for time-critical events);
  (b) Data Breach Response Plan (for cyber/data events);
  (c) Child Safety Policy (for child-related events);
  (d) Vulnerable Passenger Policy (for vulnerable-passenger events).

3. NOTIFIABLE OCCURRENCES

3.1 A "Notifiable Occurrence" is an incident that must be reported to the NSW Point to Point Transport Commissioner under the Point to Point Transport (Taxis and Hire Vehicles) Act 2016 (NSW) and its Regulation.

3.2 The Reservo platform classifies the following incident types as Notifiable Occurrences:
  (a) any incident involving death or hospitalisation;
  (b) any assault, sexual misconduct, or threat with weapon;
  (c) any incident involving alleged criminal conduct;
  (d) any vehicle collision with significant property damage or injury;
  (e) any incident involving an unaccompanied minor or child-safety concern;
  (f) any incident requiring NSW Police or NSW Ambulance attendance;
  (g) any incident the Commissioner has directed Reservo to report.

3.3 Notifiable Occurrences are reported to the Commissioner within the statutory timeframe (typically 24 hours for serious matters, 7 days for less serious matters).

4. SEVERITY CLASSIFICATION

4.1 Reservo classifies incidents into four severity levels:
  (a) CRITICAL — death, life-threatening injury, sexual misconduct, child safety concern, weapon involvement, mass-casualty event;
  (b) HIGH — significant injury (hospitalisation), physical assault, dangerous driving with risk to others, vehicle collision with significant damage;
  (c) MEDIUM — minor injury, harassment, threats, fatigue event, vehicle defect;
  (d) LOW — lost property, minor cosmetic damage, conduct concern not rising to harassment.

4.2 Severity determines:
  (a) admin notification urgency (SMS+email immediately for critical, email for high, in-app notification for medium and low);
  (b) reporting timeframe to Commissioner where Notifiable;
  (c) investigation priority.

5. REPORTING CHANNELS

5.1 Incidents may be reported through:
  (a) the in-app incident reporting form (preferred for all parties);
  (b) admin@reservo.au;
  (c) 0435 679 630;
  (d) SOS feature for time-critical safety events (which automatically logs an incident).

5.2 Drivers MUST report all of the following through the in-app form:
  (a) any accident or near-miss while on a Reservo trip;
  (b) any safety incident or threat involving a Rider;
  (c) any damage to the vehicle by a Rider;
  (d) any lost-property report;
  (e) any request from a regulatory or law-enforcement body relating to a trip.

5.3 Riders may report any incident through the in-app form.

6. INFORMATION COLLECTED

6.1 Each incident report captures:
  (a) reporter name and role;
  (b) incident type;
  (c) date, time, and location;
  (d) description in the reporter's own words;
  (e) whether injuries were reported;
  (f) whether medical / ambulance was called;
  (g) whether police were called and any report number;
  (h) witness details where available;
  (i) photographic evidence where required.

7. INVESTIGATION

7.1 The Reservo Operations team:
  (a) reviews each incident report within the response timeframe applicable to its severity;
  (b) determines whether the incident is a Notifiable Occurrence and submits the regulatory notification;
  (c) preserves evidence (GPS, messages, ratings, dashcam where available);
  (d) interviews involved parties and witnesses;
  (e) reaches findings and documents them in the incident register;
  (f) coordinates with NSW Police where criminal matters are involved.

8. ACTIONS AVAILABLE

8.1 Findings may result in:
  (a) corrective training or coaching;
  (b) account warning;
  (c) temporary or permanent suspension;
  (d) termination;
  (e) referral to NSW Police;
  (f) referral to the NSW Point to Point Transport Commissioner;
  (g) referral to anti-discrimination authorities;
  (h) compensation through the damage-claim or refund processes.

9. STATUTORY TIMEFRAMES

9.1 The Reservo platform tracks statutory reporting deadlines for each incident classified as Notifiable, alerting Operations and the Operator as deadlines approach.

9.2 Failure to report a Notifiable Occurrence within the statutory timeframe is a serious matter under the Act and may result in penalties.

10. RECORDS

10.1 Every incident report and its handling is recorded in the incident register, retained for at least 7 years from the date of resolution.

10.2 Incident statistics are reviewed quarterly to identify trends.

11. CONFIDENTIALITY

11.1 Incident details are confidential and shared only with persons necessary for investigation, reporting, or response.

11.2 Personal information of involved parties is handled in accordance with the Reservo Privacy Policy.

12. PROTECTION FROM RETALIATION

12.1 Reservo prohibits retaliation against any person reporting an incident in good faith, including but not limited to retaliatory ratings, complaints, or termination.

13. REVIEW

13.1 This policy is reviewed at least annually and after any significant incident.

---
VERSION HISTORY
v1.0 — 17/05/2026 — Initial draft for solicitor review.

---
THIS DOCUMENT IS A DRAFT FOR PRE-LAUNCH REVIEW.`,
};